var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('home-header'),_c('div',{staticClass:"footer-bg"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('div',{attrs:{"id":"home-canvas"}})])
}]

export { render, staticRenderFns }